import { Pagination as MuiPagination } from "@mui/material";

const PAGE_SIZE = 25;

const Pagination = ({ offset, setOffset, count }) => {
  const onChange = (event, value) => {
    setOffset(Math.round(value * PAGE_SIZE - PAGE_SIZE));
  };

  if (count == 0) return <></>;

  return (
    <>
      {count && (
        <MuiPagination
          count={Math.ceil(count / PAGE_SIZE)}
          page={Math.round((offset || 0) / PAGE_SIZE) + 1}
          onChange={onChange}
          shape="rounded"
        />
      )}
    </>
  );
};

export default Pagination;
